import { apiCall } from "../../../_utils";
import { apiUrls } from "../../../_constants";

export const domainService = {
  getAllDomains,
  addDomain,
  getDomain
};

function getAllDomains() {
  return apiCall("GET", apiUrls.domains.base);
}

function addDomain(request) {
  const method = request && request.id ? "PUT" : "POST";
  return apiCall(method, apiUrls.domains.base, request);
}

function getDomain(id) {
  return apiCall("GET", `${apiUrls.domains.base}/${id}`);
}
